export default function CTABanner() {
  return (
    <section className="relative py-28 md:py-36 px-6 md:px-10 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20view%20of%20a%20bright%20modern%20boutique%20interior%20with%20neatly%20displayed%20fashion%20items%20on%20minimalist%20shelving%2C%20warm%20terracotta%20and%20cream%20color%20palette%2C%20soft%20diffused%20overhead%20lighting%2C%20empty%20peaceful%20retail%20space%20with%20elegant%20product%20arrangements%2C%20upscale%20editorial%20commercial%20photography%2C%20clean%20lines%20and%20organic%20textures%2C%20inviting%20serene%20atmosphere&width=1600&height=600&seq=cta-banner-v2&orientation=landscape"
          alt="Shop smarter with Superbuy Spreadsheet"
          title="Superbuy Spreadsheet — ready to shop smarter"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/50 via-foreground-900/30 to-foreground-900/10"></div>
      </div>

      <div className="relative max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
          <div>
            <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-none">
              ready to shop<br />smarter?
            </h2>
          </div>
          <div className="flex flex-col items-start gap-6">
            <p className="text-base md:text-lg text-background-50/80 leading-relaxed max-w-md">
              Trusted by 10,000+ buyers.<br />
              One click to your next spreadsheet.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-background-50 text-foreground-900 rounded-full text-sm font-semibold hover:bg-background-50/90 transition-all duration-300 whitespace-nowrap cursor-pointer group"
            >
              Jump to Store
              <span className="w-5 h-5 rounded-full bg-foreground-900 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                <i className="ri-arrow-right-line text-xs text-background-50"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}